import React, { Component } from 'react';
import { removeSpaces } from '../../../../services/formatters/removeSpaces';
import styles from './style.scss';
import { inject } from 'mobx-react';
import ControlledCheckbox from '../../../portal/controls/checkbox/controlledCheckbox';
import { sort } from '../../../../services/utils';

@inject('rolesStore')
export default class Checkboxes extends Component {

    togglePermission = permissionId => {
        
        if(this.props.rolesStore.permissionIds.includes(permissionId)){
            this.props.rolesStore.removePermissionId(permissionId);
        }
        else{
            this.props.rolesStore.setPermissionId(permissionId);
        }
    }

    render() {
        
        const data = sort(this.props.data)('name')('asc');
        
        return (
            <div>
                {
                    data.map(item => {

                        const text = removeSpaces(item.name);
                        
                        return <div
                                    key={item.id}
                                    className={styles.permissionItem}>
                                    
                                    <ControlledCheckbox
                                        text={text}
                                        dataKey={ item.id }
                                        checked={ this.props.rolesStore.permissionIds.includes(item.id) }
                                        onCheck={this.togglePermission}/>
                                </div>
                    })
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/roles/editRole/permissionsItem/checkboxes.jsx